const ALLOWED_FLOATING_PATH_PREFIXES = ['/?', '/search', '/discover', '/computer'];
const ALLOWED_FLOATING_PATH_MATCHES = ['/'];
export const onFloatingComponentProhibitedPath = (pathname) => {
    if (!pathname) {
        return true;
    }
    return (!ALLOWED_FLOATING_PATH_MATCHES.some((p) => pathname === p) &&
        !ALLOWED_FLOATING_PATH_PREFIXES.some((p) => pathname.startsWith(p)));
};
//# sourceMappingURL=onFloatingComponentProhibitedPath.js.map